// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__28X99","detailsBorder":"styles_detailsBorder__2YW8G"};